export default "__VITE_ASSET__DhCq4Id3__"